let _Math = require("../lib/Math");

let histogram = (data, getY) => {
  let extent = data.length ? d3.extent(data, getY) : [0, 1];
  let bins = d3.histogram().domain(extent)(data.map(getY));
  let step = d3.max(bins, (bin) => bin.x1 - bin.x0) || 1;
  let n = bins.length - 1;
  let a = _Math.round(bins[0].x0, -step);
  let b = _Math.round(bins[n].x1, step);
  let s = step || 1;

  if (a === b) {
    a--;
    b++;
  }

  bins[0].x0 = a;
  bins[n].x1 = b;

  return {
    data: bins,
    domainX: b ? [a, b] : [0, 1],
    domainY: [0, d3.max(bins, (bin) => bin.length) || 1],
    stepX: [s, s * 2, s * 4],
    getX: (bin) => bin.x0,
    getY: (bin) => bin.length
  };
};

let trend = (data, getX, getY) => {
  let _data = data.filter((d) => {
    let y = getY(d);
    return y !== null && y !== undefined && !isNaN(y);
  });

  let points = _data.map((d, i) => [getX(d, i), getY(d)]);
  let trend = _Math.trend(points);

  return (d) => trend(getX(d));
};

let frequency = (data, getX, getY) => {
  let results = [];

  data.forEach((d, i) => {
    let x = getX(d, i);
    let y = getY(d);

    let found = results.find((a) => a.x === x && a.y === y);

    if (found) {
      found.z++;
    }
    else {
      results.push({ x, y, z: 1 });
    }
  });

  return {
    data: results,
    getX: (d) => d.x,
    getY: (d) => d.y,
    getZ: (d) => d.z
  };
};

let stack = (data, getX, getY) => {
  let results = data.map((d, i) => {
    let y = getY(d);

    return {
      x: getX(d, i),
      y: [0].concat(y.map((n, i) => d3.sum(y.slice(0, i)) + n))
    };
  });

  return {
    data: results,
    getX: (d, i) => d.x,
    getY: data.map((d, i) => (d) => d.y.slice(i, i + 2)),
    domainY: [0, d3.max(results, (d) => d3.max(d.y))]
  };
};

module.exports = { histogram, trend, frequency, stack };